<app-back-button *ngIf="showBackButton" />

<a *ngIf="showCustomerSpaceName" class="customer-space-name" [ngClass]="{ 'has-image': hasImage }"
  [routerLink]="customerSpaceLink">
  <span>{{ customerSpaceName }}</span>
</a>

<a *ngIf="legalEntityName" [routerLink]="legalEntityLink" class="customer-space-name" [ngClass]="{ 'has-image': hasImage }">
  <span>{{ legalEntityName }}</span>
</a>